import { useState } from 'react'
import AttendeeData from '@/components/attendee/AttendeeData'
import { SiteHeader } from '@/components/site-header'
import { TabbedSection } from '@/components/TabbedSection'
import { EventAttendeesTable } from '@/components/event/EventAttendeesTable'
import { EVENT_ATTENDEE_TABS } from '@/constants/event'

function AttendeeManagement() {
  const [searchQuery, setSearchQuery] = useState('')
  const [activeTab, setActiveTab] = useState(
    EVENT_ATTENDEE_TABS.EVENT_REGISTRATIONS
  )

  const handleSearchChange = (value: string) => {
    setSearchQuery(value)
  }

  const handleTabChange = (value: string) => {
    setActiveTab(value)
    // Clear search when switching tabs
    setSearchQuery('')
  }

  const tabs = [
    {
      value: EVENT_ATTENDEE_TABS.EVENT_REGISTRATIONS,
      label: 'Event Registrations',
      content: <AttendeeData searchQuery={searchQuery} />,
    },
    {
      value: EVENT_ATTENDEE_TABS.EVENT_ATTENDEE_BOOKINGS,
      label: 'Event Attendee Bookings',
      content: <EventAttendeesTable externalSearchQuery={searchQuery} />,
    },
  ]

  return (
    <main
      className="@container/main flex flex-1 flex-col"
      id="main-content"
      tabIndex={-1}
      aria-label="Attendee Management Main Content"
    >
      <section
        aria-label="Attendee Management Header and Actions"
        className="flex flex-col gap-4 md:gap-6"
      >
        <SiteHeader
          title="Attendee Management"
          subtitle="View and manage all ticket purchasers for your event in real time"
          searchPlaceholder={
            activeTab === 'registrations'
              ? 'Search attendees...'
              : 'Search bookings...'
          }
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />
      </section>

      <section aria-label="Attendees Data" className="mt-6">
        <TabbedSection
          activeTab={activeTab}
          onTabChange={handleTabChange}
          tabs={tabs}
          className="mx-4 h-15"
        />
      </section>
    </main>
  )
}

export default AttendeeManagement
